import { Flex, IconButton } from '@radix-ui/themes'
import { Cross1Icon } from '@radix-ui/react-icons'
import React, { useState } from 'react'

import { DocumentsFilter } from '@/interfaces/CardOne'
import InputField from '@/components/InputField'

const UserFilter: React.FC<{
  filterData: DocumentsFilter
  setFilterData: React.Dispatch<React.SetStateAction<DocumentsFilter>>
}> = ({ filterData = {}, setFilterData }) => {
  const [showFilters, setShowFilters] = useState<boolean>(false)
  const label = showFilters ? 'Esconder filtros de búsqueda' : 'Ver filtros de búsqueda'

  return (
    <>
      <div className="flex justify-center mb-2">
        <button className="text-blue-500 font-bold" onClick={() => setShowFilters(!showFilters)} aria-label="Ver">
          {label}
        </button>
      </div>

      {showFilters && (
        <div className="grid grid-cols-1 sm:grid-cols-5 gap-x-2">
          <InputField
            handleInputChange={({ target }) => {
              console.log('Typing in salesPerson:', target.value)
              console.log('Current filterData:', filterData)
              setFilterData({ ...filterData, salesPerson: target.value })
            }}
            value={filterData.salesPerson || ''}
            placeholder="Buscar por nombre..."
            label="Vendedor"
            type="text"
            name="user"
          />

          <label className="font-semibold flex flex-col">
            Desde
            <Flex justify="between" align="center" gap="1" mt="1">
              <input
                onChange={({ target }) => {
                  setFilterData({ ...filterData, dateSince: target.value })
                }}
                className="border rounded p-2 flex-1"
                max={filterData.dateUntil?.valueOf()}
                value={filterData.dateSince || ''}
                name="date-since"
                type="date"
              />
              <IconButton
                onClick={() => {
                  setFilterData({ ...filterData, dateSince: '' })
                }}
                disabled={!filterData.dateSince}
                aria-label="Limpiar fecha desde"
                className="flex-0"
                variant="outline"
                size="3"
              >
                <Cross1Icon />
              </IconButton>
            </Flex>
          </label>
          <label className="font-semibold flex flex-col">
            Hasta
            <Flex justify="between" align="center" gap="1" mt="1">
              <input
                onChange={({ target }) => {
                  setFilterData({ ...filterData, dateUntil: target.value })
                }}
                className="border rounded p-2 flex-1"
                value={filterData.dateUntil || ''}
                min={filterData.dateSince}
                name="date-until"
                type="date"
              />
              <IconButton
                onClick={() => {
                  setFilterData({ ...filterData, dateUntil: '' })
                }}
                disabled={!filterData.dateUntil}
                aria-label="Limpiar fecha hasta"
                className="flex-0"
                variant="outline"
                size="3"
              >
                <Cross1Icon />
              </IconButton>
            </Flex>
          </label>
        </div>
      )}
    </>
  )
}

export default UserFilter
